export default {
  serverURL: process.env.REACT_APP_API_URL,
  AUTH: {
    TOKEN: 'Authorization'
  }
};
